import { render } from "./CinemaSearch.vue?vue&type=template&id=2487f294&scoped=true"
import script from "./CinemaSearch.vue?vue&type=script&lang=js"
export * from "./CinemaSearch.vue?vue&type=script&lang=js"

import "./CinemaSearch.vue?vue&type=style&index=0&id=2487f294&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_0435b427d4926b97c683d68ac9fd935c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2487f294"]])

export default __exports__